export default class Auth {
    constructor(email, password) {
        this.email = email;
        this.password = password
    }
} 